import { Navigate } from "react-router";

/**
 * Almikia Epic EC2a: Empresas and Colegas lost their menu tabs (one address book: the contacts
 * list). The resources, tables and deep links stay; only the two LIST routes redirect.
 */

/** Where the legacy Colegas list lands: the contacts list filtered to the Colega type. */
export const COLEGA_CONTACTS_LOCATION = {
  pathname: "/contacts",
  search: `?filter=${encodeURIComponent(
    JSON.stringify({ "contact_types@cs": "{colega}" }),
  )}`,
};

/** Replaces the `/companies` list: sends the visitor to the contacts list. */
export const CompaniesListRedirect = () => <Navigate to="/contacts" replace />;

/** Replaces the `/colegas` list: contacts list with the Colega type filter applied. */
export const ColegasListRedirect = () => (
  <Navigate to={COLEGA_CONTACTS_LOCATION} replace />
);

/** Path under which the legacy Colegas screen stays registered (no menu entry points to it). */
export const LEGACY_COLEGAS_SCREEN_PATH = "/colegas/legacy";
